export default "__VITE_ASSET__BqKRjAar__"